import { Injectable } from '@angular/core';
import { ValueFormatterParam } from './group-row-data';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class GroupRowRendererService {
    constructor(private translateService: TranslateService) {}

    public getGroupRowValue(params: ValueFormatterParam, valueFormatter: ((params: ValueFormatterParam) => string) | string): string {
        let value = undefined;
        if (typeof valueFormatter === 'function') {
            value = valueFormatter(params);
        } else if (!!params.value) {
            value = params.value;
        }
        return value || this.translateService.instant('EntityList.noValueItem');
    }
}
